const KEY = "deliveryAddress";
/**
 * Saves and restores StreetAddress from/to the previous implementation's address storage.
 */
export class LegacyStreetAddressStorageManager {
    constructor(data) {
        this.data = data;
    }
    store() {
        var _a;
        const stored = (_a = this.readFromStorage()) !== null && _a !== void 0 ? _a : {};
        stored.city = this.data.city;
        stored.street = this.data.street;
        stored.streetNumber = this.data.streetNumber;
        stored.postCode = this.data.postCode;
        this.writeToStorage(stored);
    }
    readFromStorage() {
        const json = localStorage.getItem(KEY);
        if (json === null) {
            return null;
        }
        return JSON.parse(json);
    }
    writeToStorage(x) {
        localStorage.setItem(KEY, JSON.stringify(x));
    }
    /**
     * @returns true if an address was found in the storage
     */
    restore() {
        var _a, _b, _c, _d, _e, _f, _g, _h;
        const stored = (_a = this.readFromStorage()) !== null && _a !== void 0 ? _a : {};
        if (stored === null ||
            !((_b = stored.city) !== null && _b !== void 0 ? _b : "") ||
            !((_c = stored.street) !== null && _c !== void 0 ? _c : "") ||
            !((_d = stored.streetNumber) !== null && _d !== void 0 ? _d : "")
        // Note: postCode not required
        ) {
            return false;
        }
        this.data.city = (_e = stored.city) !== null && _e !== void 0 ? _e : "";
        this.data.street = (_f = stored.street) !== null && _f !== void 0 ? _f : "";
        this.data.streetNumber = (_g = stored.streetNumber) !== null && _g !== void 0 ? _g : "";
        this.data.postCode = (_h = stored.postCode) !== null && _h !== void 0 ? _h : "";
        return true;
    }
}
